export default __webpack_public_path__ + "static/media/Träslöjd3.367a1574.jpeg";